module.exports = __webpack_public_path__ + "static/media/WaitingForCustomerSignature.f4d5ba54.svg";